var map = {
	"./DELTA_logo1.jpg": 725,
	"./ERSTE_logo1.jpg": 726,
	"./ILIRIK_logo1.jpg": 727,
	"./M&V_logo1.jpg": 728,
	"./MMNT_logo1.jpg": 729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 724;